import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "container",
  style: {"margin-top":"90px"}
}
const _hoisted_2 = { class: "jumbotron" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-5 col-sm-6 text-right" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "list-group" }
const _hoisted_10 = { class: "d-flex w-100 justify-content-between" }
const _hoisted_11 = { class: "mb-1" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = { key: 3 }
const _hoisted_16 = { key: 4 }
const _hoisted_17 = { class: "mb-1" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { key: 2 }
const _hoisted_21 = { key: 3 }
const _hoisted_22 = { key: 4 }

import { computed, ref, watch, onMounted, onUnmounted } from 'vue'
    import { useId, useOrganizationUnitId } from '@common/composables'
    import { useInterval } from '@composables/useInterval'
    import { useUserActivity } from '@composables/useUserActivity'
    import { usePageReloaded } from '@composables/usePageReloaded'
    import { usePipelineTriggerPage } from '@Integrations/Pipelines/pages-core'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'PipelineTriggerPage',
  setup(__props) {

    document.title = "Pipeline trigger"

    const connectorProviderReadPage = ref(null);
    const connectorProviderWritePage = ref(null);

    const tid = useOrganizationUnitId()
    const id = useId()
    const pageReloaded = usePageReloaded()
    const { isUserActive } = useUserActivity(20000)

    const { useCurrentUserQuery, usePipelineTriggerQuery, useLastRunsForPipelineByUserQuery, useTriggerPipelineManuallyCommand } = usePipelineTriggerPage()

    const { modelCurrentUserQueryV1, runCurrentUserQueryV1 } = useCurrentUserQuery()
    const userId = computed(() => modelCurrentUserQueryV1.value?.UserId)

    const { runPipelineTriggerQueryV1, modelPipelineTriggerQueryV1 } = usePipelineTriggerQuery(id)
    const pipelineName = computed(() => modelPipelineTriggerQueryV1.value?.Name)
    const direction = computed(() => modelPipelineTriggerQueryV1.value?.Direction)
    const connectorId = computed(() => modelPipelineTriggerQueryV1.value?.ConnectorId)
    const connectorIsReady = computed(() => modelPipelineTriggerQueryV1.value?.ConnectorIsReady)
    const connectorStatus = computed(() => modelPipelineTriggerQueryV1.value?.ConnectorStatus)
    const connectorProviderReadPageUrl = computed(() => modelPipelineTriggerQueryV1.value?.ConnectorProviderReadPageUrl)
    const connectorProviderWritePageUrl = computed(() => modelPipelineTriggerQueryV1.value?.ConnectorProviderWritePageUrl)

    const { modelLastRunsForPipelineByUserQueryV1, runLastRunsForPipelineByUserQueryV1 } = useLastRunsForPipelineByUserQuery(id, userId, false)
    const runs = computed(() => modelLastRunsForPipelineByUserQueryV1.value?.Runs ?? [])

    const { invokeTriggerPipelineManuallyCommandV1, succeedTriggerPipelineManuallyCommandV1 } = useTriggerPipelineManuallyCommand(id, tid, userId)

    useInterval(() => {
        if (isUserActive.value) {
            runPipelineTriggerQueryV1()
            runLastRunsForPipelineByUserQueryV1()
        }
    },
    5000)

    onMounted(() => {
        runCurrentUserQueryV1()
        runPipelineTriggerQueryV1()
    })

    watch(userId, () => userId.value && runLastRunsForPipelineByUserQueryV1())

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _cache[5] || (_cache[5] = _createStaticVNode("<nav class=\"navbar navbar-expand-lg fixed-top navbar-dark bg-dark\"><button class=\"navbar-toggler\" type=\"button\" data-toggle=\"collapse\" data-target=\"#Navigation\"><span class=\"navbar-toggler-icon\"></span></button><div class=\"collapse navbar-collapse\" id=\"Navigation\"><ul class=\"navbar-nav mr-auto\"><li class=\"nav-item\"><a class=\"navbar-brand\" href=\"/#/organizations/users/dashboard\">Home</a></li></ul></div></nav>", 1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "col-lg-7" }, [
            _createElementVNode("h1", { style: {"font-size":"2em","font-weight":"300","color":"#33475b"} }, "Integration Pipeline Trigger")
          ], -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(invokeTriggerPipelineManuallyCommandV1) && _unref(invokeTriggerPipelineManuallyCommandV1)(...args))),
              class: "btn btn-success",
              disabled: direction.value != 2 && !connectorIsReady.value
            }, [...(_cache[1] || (_cache[1] = [
              _createElementVNode("i", {
                class: "fa fa-bolt",
                "aria-hidden": "true"
              }, null, -1 /* CACHED */),
              _createTextVNode(" Run pipeline ", -1 /* CACHED */)
            ]))], 8 /* PROPS */, _hoisted_5)
          ])
        ]),
        _createElementVNode("span", null, [
          _cache[3] || (_cache[3] = _createTextVNode("Run integration pipeline ", -1 /* CACHED */)),
          _createElementVNode("strong", null, _toDisplayString(pipelineName.value), 1 /* TEXT */)
        ]),
        _cache[4] || (_cache[4] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 30px"} }, null, -1 /* CACHED */)),
        (connectorStatus.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, "Status: " + _toDisplayString(connectorStatus.value), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        (connectorProviderReadPageUrl.value)
          ? (_openBlock(), _createElementBlock("iframe", {
              key: 1,
              ref_key: "connectorProviderReadPage",
              ref: connectorProviderReadPage,
              name: "connectorProviderReadPage",
              src: `${connectorProviderReadPageUrl.value}${_unref(tid)}?pipelineId=${_unref(id)}&connectorId=${connectorId.value}`,
              style: {"border":"none","background":"none","width":"100%"}
            }, null, 8 /* PROPS */, _hoisted_7))
          : _createCommentVNode("v-if", true),
        (connectorProviderWritePageUrl.value)
          ? (_openBlock(), _createElementBlock("iframe", {
              key: 2,
              ref_key: "connectorProviderWritePage",
              ref: connectorProviderWritePage,
              name: "connectorProviderWritePage",
              src: `${connectorProviderWritePageUrl.value}${_unref(tid)}?pipelineId=${_unref(id)}&connectorId=${connectorId.value}`,
              style: {"border":"none","background":"none","width":"100%"}
            }, null, 8 /* PROPS */, _hoisted_8))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(runs.value, (r) => {
            return (_openBlock(), _createElementBlock("a", {
              key: r.RunId,
              class: _normalizeClass(["list-group-item list-group-item-action", {'list-group-item-secondary': r.Queued, 'list-group-item-primary': r.Running, 'list-group-item-success': r.Succeed, 'list-group-item-danger': (r.Failed || r.Aborted) && !r.Succeed}])
            }, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("h6", _hoisted_11, [
                  (r.Running)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, "[Running]"))
                    : (r.Succeed)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_13, "[Succeed]"))
                      : (r.Failed)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, "[Failed(" + _toDisplayString(r.FailuresCount) + ")]", 1 /* TEXT */))
                        : (r.Aborted)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_15, "[Aborted]"))
                          : (_openBlock(), _createElementBlock("span", _hoisted_16, "[Queued]")),
                  _createTextVNode(" " + _toDisplayString(r.PipelineName), 1 /* TEXT */)
                ]),
                _createElementVNode("small", null, [
                  _createElementVNode("span", null, _toDisplayString(r.LastActivityAtSinceNow) + " ago", 1 /* TEXT */)
                ])
              ]),
              _createElementVNode("p", _hoisted_17, [
                _createTextVNode(_toDisplayString(r.Trigger) + " ", 1 /* TEXT */),
                (r.QueuedByName)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_18, "by " + _toDisplayString(r.QueuedByName), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("span", null, _toDisplayString(r.QueuedAtSinceNow) + " ago", 1 /* TEXT */),
                (r.StartedAtSinceNow)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_19, "/ started " + _toDisplayString(r.StartedAtSinceNow) + " ago", 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                (r.CompletedAtSinceNow)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_20, "/ completed " + _toDisplayString(r.CompletedAtSinceNow) + " ago", 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                (r.FailedAtSinceNow)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_21, "/ failed " + _toDisplayString(r.FailedAtSinceNow) + " ago", 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                (r.AbortedAtSinceNow)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_22, "/ aborted " + _toDisplayString(r.AbortedAtSinceNow) + " ago", 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ])
            ], 2 /* CLASS */))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ])
    ])
  ]))
}
}

})